<script>
export default {
  props: ['fastData'],
  data () {
    return {
      rangeoption1: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Ua', 'Ub', 'Uc'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20,
          x2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39', '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59', '60', '61', '62', '63', '64', '65', '66', '67', '68', '69', '70', '71', '72', '73', '74', '75', '76', '77', '78', '79', '80', '81', '82', '83', '84', '85', '86', '87', '88', '89', '90', '91', '92', '93', '94', '95', '96', '97', '98', '99', '100', '101', '102', '103', '104', '105', '106', '107', '108', '109', '110', '111', '112', '113', '114', '115', '116', '117', '118', '119', '120', '121', '122', '123', '124', '125', '126', '127', '128', '129', '130', '131', '132', '133', '134', '135', '136', '137', '138', '139', '140', '141', '142', '143', '144', '145', '146', '147', '148', '149', '150', '151', '152', '153', '154', '155', '156', '157', '158', '159', '160', '161', '162', '163', '164', '165', '166', '167', '168', '169', '170', '171', '172', '173', '174', '175', '176', '177', '178', '179', '180', '181', '182', '183', '184', '185', '186', '187', '188', '189', '190', '191', '192', '193', '194', '195', '196', '197', '198', '199', '200']
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ua',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ub',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Uc',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }
        ]
      },
      rangeoption2: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var relVal = params[0].name
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + '%'
            }
            return relVal
          }
        },
        legend: {
          data: ['Ia', 'Ib', 'Ic', 'In'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        grid: {
          y2: 20,
          x2: 20
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          data: []
        }],
        yAxis: [{
          type: 'value',
          axisLabel: {
            formatter: '{value} %'
          }
        }],
        series: [{
          name: 'Ia',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: []
        }, {
          name: 'Ib',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: []
        }, {
          name: 'Ic',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: []
        }, {
          name: 'In',
          type: 'bar',
          showSymbol: false,
          itemStyle: {
            color: '#00a1f5'
          },
          data: []
        }
        ]
      },
      chart: {},
      posSelectOptions: [{
        value: 1,
        label: '电压'
      }, {
        value: 2,
        label: '电流'
      }],
      posSelectValue: 1,
      // 频段下拉框
      // freqSelectOptions: [{
      //   value: 1,
      //   label: '1~50 次'
      // }, {
      //   value: 2,
      //   label: '51~100 次'
      // }, {
      //   value: 3,
      //   label: '101~150 次'
      // }, {
      //   value: 4,
      //   label: '151~200 次'
      // }],
      // freqSelectValue: 1,
      showRms: {}
    }
  },
  watch: {
    posSelectValue () {
      this.Chart.clear()
      this.setValue(this.fastData)
    },
    fastData () {
      this.setValue(this.fastData)
    }
  },
  mounted () {
    this.Chart = this.$echarts.init(document.getElementById('rangeOptions'))

    this.setValue(this.fastData)
  },
  destroyed () {

  },
  methods: {
    setValue (data) {
      if (this.posSelectValue === 1) {
        this.showRms = {
          a: Number(data ? data.ua_rms : 0).toFixed(1) + 'V',
          b: Number(data ? data.ub_rms : 0).toFixed(1) + 'V',
          c: Number(data ? data.uc_rms : 0).toFixed(1) + 'V'
        }
        this.rangeoption1.series[0].data = data.fast_fft_ua
        this.rangeoption1.series[1].data = data.fast_fft_ub
        this.rangeoption1.series[2].data = data.fast_fft_uc
        this.Chart.setOption(this.rangeoption1)
      } else if (this.posSelectValue === 2) {
        this.showRms = {
          a: Number(data ? data.ia_rms : 0).toFixed(1) + 'A',
          b: Number(data ? data.ib_rms : 0).toFixed(1) + 'A',
          c: Number(data ? data.ic_rms : 0).toFixed(1) + 'A',
          n: Number(data ? data.in_rms : 0).toFixed(1) + 'A'
        }
        this.rangeoption2.series[0].data = data.fast_fft_ia
        this.rangeoption2.series[1].data = data.fast_fft_ib
        this.rangeoption2.series[2].data = data.fast_fft_ic
        this.rangeoption2.series[3].data = data.fast_fft_in
        this.Chart.setOption(this.rangeoption2)
      }
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">高速采样谐波频谱图</div>

      <div style="display: flex; flex-wrap: wrap; height: 35px; line-height: 35px; margin-bottom: 10px;">
        <div style="display: flex; width: 100%; flex-direction: column">
          <div
            style="display: flex; align-items: center; margin-left: 20px;">
            <div style="width: 80px;">电气量</div>

            <div style="width: 150px; font-size: 20px; margin-left: 10px">
              <el-select v-model="posSelectValue" placeholder="请选择" size="20px">
                <el-option
                  v-for="item in posSelectOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </div>

        </div>
      </div>
      <div style="height: calc(100% - 155px);">
        <div id="rangeOptions" style="height: 100%; width: 100%; border-top: 1px solid black"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.pg {
  width: 98%;
  height: calc(90vh - 150px);
}

.dataName {
  width: 10%;
}

.dataValue {
  width: 10%;
//border-right: 1px solid black;
}

.dataTitle {
  height: 30px;
}

.dataNvItem {
  height: calc((100% - 70px) / 10);
}

.el-input--suffix .el-input__inner {
  font-size: 20px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Speed/SpeedThdChart/SpeedThdChart.vue